import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import axiosInstance from "../../utils/axiosInstance";
import { redirect, useLocation, useNavigate, useParams } from "react-router-dom";
import { addAppointment, fetchAcceptedPendingAppointmentsOfDoctorByDate, fetchCoupons, fetchDoctorProfile, fetchPatients, imageBaseUrl } from "../../constants/ApiConstants";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { linearTopGradient } from "../../constants/colors";
import toast from "react-hot-toast";
import AppointmentTimeInfo from "./comps/AppointmentTimeInfo";
import AppointmentOrderSummary from "./comps/AppointmentOrderSummary";
import MyModal from "../../components/MyModal";
import CouponBox from "../../components/CouponBox";

import Spinner from "../../components/Spinner";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";

export default function AppointmentSummary() {
  pageTitle("Appointment Summary");

  const location = useLocation();
  const navigate = useNavigate();
  const doctorDetail = location.state?.doctorData;
  const settings = useSelector((state) => state.appSlice.settings);

  const [appointmentData, setAppointmentData] = useState(location.state?.appointmentData);

  console.log({ state: location.state });

  const [loading, setLoading] = useState(false);

  const userId = useSelector((state) => state.appSlice.userData?.id);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [coupons, setCoupons] = useState([]);
  const [selectedCoupon, setSelectedCoupon] = useState();
  const appTaxes = useSelector((state) => state.appSlice.settings.taxes);
  const [submitting, setSubmitting] = useState(false);

  const toggleCouponModalVisible = () => {
    setShowCouponModal(!showCouponModal);
  };

  useEffect(() => {
    if (!location.state) {
      console.log("doctorDetail nout found");
      return navigate("/page-not-found");
    }
    fetchCouponData();
  }, []);

  const fetchCouponData = () => {
    axiosInstance
      .post(fetchCoupons, { user_id: userId })
      .then((res) => {
        setCoupons(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCouponClick = (coupon) => {
    const couponMaxDiscountAmount = parseFloat(coupon.max_discount_amount);
    const discountAmount = appointmentData.service_amount / parseFloat(coupon.percentage) / 100;
    let updatedSubtotal = appointmentData.subtotal;
    if (discountAmount > appointmentData.subtotal) {
      updatedSubtotal -= couponMaxDiscountAmount;
    } else {
      updatedSubtotal -= discountAmount;
    }

    recalculateFees(updatedSubtotal, discountAmount);
    setSelectedCoupon(coupon);
    toggleCouponModalVisible();
  };

  const recalculateFees = (subtotal, discount) => {
    const newAppointmentData = { ...appointmentData };

    // coupon did not apply
    if (discount === 0) {
      newAppointmentData.discount_amount = 0;
      newAppointmentData.is_coupon_applied = 0;
      newAppointmentData.order_summary.coupon_apply = 0;
    } else {
      // assuming that coupon has been applied.
      newAppointmentData.discount_amount = discount;
      newAppointmentData.is_coupon_applied = 1;
      newAppointmentData.order_summary.coupon_apply = 1;
    }

    newAppointmentData.subtotal = subtotal;
    newAppointmentData.order_summary.subtotal = subtotal;

    let payableAmount = subtotal;
    let totalTaxAmount = 0;

    const taxes = [];
    for (const taxItem of appTaxes) {
      let taxAmount;
      if (taxItem.type == 0) {
        // percent
        taxAmount = (subtotal * parseFloat(taxItem.value)) / 100;
      } else if (taxItem.type == 1) {
        taxAmount = parseFloat(taxItem.value);
      }
      totalTaxAmount += taxAmount;
      payableAmount += taxAmount;
      taxes.push({ ...taxItem, tax_amount: taxAmount });
    }

    newAppointmentData.order_summary.taxes = taxes;
    newAppointmentData.total_tax_amount = totalTaxAmount;
    newAppointmentData.payable_amount = payableAmount;
    newAppointmentData.order_summary.payable_amount = payableAmount;

    console.log(newAppointmentData);

    setAppointmentData(newAppointmentData);
  };

  const onRemoveCoupon = () => {
    recalculateFees(appointmentData?.service_amount, 0);
    setSelectedCoupon(null);
  };
  const validateAndSubmit = async () => {
    const formdata = new FormData();
    formdata.append("date", appointmentData.date);
    formdata.append("doctor_id", appointmentData.doctor_id);
    formdata.append("is_coupon_applied", appointmentData.is_coupon_applied);
    formdata.append("problem", appointmentData.problem);
    formdata.append("time", appointmentData.time);
    formdata.append("type", appointmentData.type);
    formdata.append("service_amount", parseInt(appointmentData.service_amount));
    formdata.append("discount_amount", parseInt(appointmentData.discount_amount));
    formdata.append("subtotal", parseInt(appointmentData.subtotal));
    formdata.append("total_tax_amount", parseFloat(appointmentData?.total_tax_amount));
    formdata.append("payable_amount", parseInt(appointmentData.payable_amount));
    formdata.append("coupon_apply", appointmentData.coupon_apply);
    formdata.append("order_summary", JSON.stringify(appointmentData.order_summary));
    formdata.append("user_id", userId);
    const documentFiles = appointmentData.documents;
    documentFiles.forEach((file) => {
      formdata.append("documents", file);
    });
    setSubmitting(true);
    axiosInstance
      .post(addAppointment, formdata, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Appointment booked successfully");
          navigate("/appointment-booked/" + res.data?.data?.appointment_number);
        } else {
          toast.error(res?.data?.message);
        }
        setSubmitting(false);
      })
      .catch((err) => {
        toast.error("Internal Server error.");
        setSubmitting(false);
      });
  };

  return (
    <>
      {/* <BannerSectionStyle3 bgUrl="/images/appointments/banner_bg.svg" imgUrl="/images/appointments/banner_img.png" title="Don’t Let Your Health Take a Backseat!" subTitle="Fill out the appointment form below to schedule a consultation with one of our healthcare professionals." /> */}
      <Section topMd={200} topLg={20} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        <div className="content-wrapper">
          <CommonMobileHeader canBack title="Confirm Booking" trailing={<div className="bg-primary text-light px-2 rounded fs-normal">{`${settings.currency} ${parseInt(doctorDetail?.wallet).toFixed(0)}`}</div>} />
          {doctorDetail && (
            <div className="row">
              <div className="col-md-6 px-2">
                <DoctorContainer>
                  <div className="doctor__image w-full px-3">
                    <img className="rounded" src={`${imageBaseUrl}${doctorDetail.image}`} />
                  </div>
                  <div className="doctor__info">
                    <strong className="doctor__name text-black">{doctorDetail.name}</strong>
                    <div className="doctor__designation d-flex align-items-center gap-1 fs-md">
                      <img src={"/images/stethoscope.png"} />
                      {doctorDetail.designation}
                    </div>
                    <span className="doctor__degrees fs-md text-grey2">{doctorDetail.degrees}</span>
                  </div>
                </DoctorContainer>
              </div>
              <div className="col-md-6 g-2 px-3">
                <AppointmentTimeInfo date={appointmentData.date} time={appointmentData.time} type={appointmentData.type == 0 ? "Online" : "Clinic"} />
                <AppointmentOrderSummary
                  isApplyCouponVisible={!selectedCoupon}
                  coupon={selectedCoupon}
                  serviceAmount={appointmentData.service_amount}
                  subtotal={appointmentData.subtotal}
                  payableAmount={appointmentData.payable_amount}
                  taxes={appointmentData?.order_summary.taxes}
                  discount={appointmentData?.discount_amount}
                  totalTaxAmount={appointmentData.total_tax_amount}
                  onAppyCouponClick={toggleCouponModalVisible}
                  onRemoveCoupon={onRemoveCoupon}
                />
                <GradientButton type="button" className="btn-gradient cs_shadow_1" onClick={validateAndSubmit}>
                  {submitting ? <Spinner size={24} /> : "Pay Now"}
                </GradientButton>
              </div>
            </div>
          )}
          <MyModal isOpen={showCouponModal} onClose={toggleCouponModalVisible} modalTitle={"Apply Coupon"} modalSubtitle={"Tap on a coupon to apply it"}>
            {coupons.map((coup) => (
              <CouponBox key={coup.id} onClick={() => handleCouponClick(coup)} code={coup.coupon} heading={coup.heading} maxDiscount={coup.max_discount_amount} validity={coup.description} />
            ))}
          </MyModal>
        </div>
      </Section>
    </>
  );
}

const DoctorContainer = styled.div`
  display: flex;
  padding-bottom: 0.75rem;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
  margin-bottom: 1rem;

  .btn-gradient {
    position: fixed;
    left: 0;
    right: 0;
    padding: 12px 16px 16px 12px;
    bottom: 0;
    color: #fff;
    outline: none;
    border: none;
    background: ${linearTopGradient};
    z-index: 5;
  }

  b span {
    color: gray;
    font-size: 0.9rem;
  }
  .doctor__designation img {
    height: 12px;
  }

  .doctor__image img {
    height: 100px;
    width: 100px;
    object-fit: contain;
  }

  .doctor__image {
    width: max-content;
  }

  @media screen and (min-width: 768px) {
    flex-direction: column;
    .doctor__designation {
      display: block !important;
    }
    .doctor__name {
      font-size: 3rem;
      margin-top: 2rem;
      text-align: center;
    }
    .doctor__image img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
    .doctor__image {
      height: 450px;
    }
    .doctor__info {
      margin: 0 auto;
      width: 100%;
      margin-top: 2rem;
      text-align: center;
    }
  }
`;
const GradientButton = styled.button`
  position: static;
  margin-top: 1rem;
  left: 0;
  right: 0;
  padding: 14px 16px 16px 14px;
  bottom: 0;
  color: #fff;
  outline: none;
  border: none;
  background: ${linearTopGradient};
  z-index: 5;
  border-radius: 8px;
  width: 100%;
  margin-left: 12px;
  margin-right: 12px;

  @media screen and (max-width: 768px) {
    position: fixed;
    margin: 0;
    border-radius: 0;
    bottom: 0;
  }
`;
